import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { ShareMatchComponentModule } from '../_shared/components/share-match/share-match.module';
import { LoginModalModule } from '../_shared/components/login-modal/login-modal.module';
import { SuspendedMatchComponentModule } from '../_shared/components/suspended-match/suspended-match.module';
import { CreateMatchModule } from '../matches/create-match/create-match.module';
import { ScoreListPageModule } from '../score-list/score-list.module';
import { ScoreboardModule } from '../scoreboard/scoreboard.module';
import { StatsFiltersModule } from '../stats/stats-filters/stats-filters.module';
import { StatsPageModule } from '../stats/stats.module';
import { MatchTrackerPage } from './match-tracker.page';
import { StartMatchModule } from './start-match/start-match.module';
import { TrackerBoardModule } from './tracker-board/tracker-board.module';
import { TrackerPopoverComponent } from './tracker-popover/tracker-popover.component';
import { TrackingModesComponent } from './tracking-modes/tracking-modes.component';
import { WeatherUpdateComponent } from './weather-update/weather-update.component';
import { FollowMatchComponent } from './follow-match/follow-match.component';
import { SelectUserModule } from '../_shared/components/select-user/select-user.module';
import { EmptyPageModule } from '../empty-page/empty-page.module';
import { AddMediaComponent } from './add-media/add-media.component';
import { MomentumChartComponent } from './momentum-chart/momentum-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { VideoTabComponent } from './video-tab/video-tab.component';

const routes: Routes = [
    {
        path: ':id',
        component: MatchTrackerPage,
        title: 'iOnCourt | Track Individual Match'
    },
    {
        path: ':id/playsight',
        component: MatchTrackerPage
    },
    {
        path: ':id/canada',
        component: MatchTrackerPage
    },
    {
        path: ':id/time-tennis',
        component: MatchTrackerPage
    },
    {
        path: ':id/stream-view/:theme',
        component: MatchTrackerPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        ScoreboardModule,
        StatsPageModule,
        TrackerBoardModule,
        ScoreListPageModule,
        CreateMatchModule,
        TranslateModule.forChild(),
        ShareMatchComponentModule,
        SuspendedMatchComponentModule,
        StatsFiltersModule,
        StartMatchModule,
        SelectUserModule,
        EmptyPageModule,
        LoginModalModule,
        NgChartsModule,
        VideoTabComponent
    ],
    declarations: [
        MatchTrackerPage,
        TrackerPopoverComponent,
        TrackingModesComponent,
        WeatherUpdateComponent,
        FollowMatchComponent,
        AddMediaComponent,
        MomentumChartComponent
    ]
})
export class MatchTrackerPageModule { }
